import { styled } from '@nykaa/ui-components';
export const Root = styled.div `
    margin-top: ${({ theme }) => theme.spacing.spacing40};
`;
export const Wrapper = styled.div `
    display: flex;
    align-items: center;
    padding: ${({ theme }) => theme.spacing.spacing20};
    border-radius: ${({ borderRadius }) => `${borderRadius}px`};
    background-image: ${({ gradient }) => (gradient || 'none')};
`;
export const Image = styled.img `
    height: 18px;
    height: 18px;
    border-radius: ${({ theme }) => theme.borders.radiusFull};
`;
export const Title = styled.div `
    padding-left: ${({ theme }) => theme.spacing.spacing20};
    text-color: ${({ textColor, theme }) => textColor || theme.colors.textSecondary};
    opacity: ${({ textTransparency }) => textTransparency || 1};
    ${({ theme }) => theme.typography.bodyXSmall};
`;
